module.exports = __webpack_public_path__ + "img/1_2.caed3568.png";